import { supabase } from '@/lib/supabase';

export interface SavedPaymentMethod {
  id: string;
  brand: string;
  last4: string;
  exp_month: number | null;
  exp_year: number | null;
  funding: string | null;
  is_default: boolean;
}

export interface ListPaymentMethodsResponse {
  customer_id: string;
  default_payment_method_id: string | null;
  payment_methods: SavedPaymentMethod[];
}

async function invoke<T>(functionName: string, body: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = await supabase.functions.invoke(functionName, { body });
  if (error) throw new Error(error.message);
  return data as T;
}

export const paymentMethodApi = {
  list() {
    return invoke<ListPaymentMethodsResponse>('stripe-list-payment-methods');
  },

  createSetupIntent() {
    return invoke<{
      setup_intent_id: string;
      client_secret: string;
      customer_id: string;
    }>('stripe-save-payment-method', { action: 'create_setup_intent' });
  },

  finalizeSetupIntent(setupIntentId: string) {
    return invoke<{
      payment_method: SavedPaymentMethod;
      is_default: boolean;
    }>('stripe-save-payment-method', {
      action: 'finalize',
      setup_intent_id: setupIntentId,
    });
  },

  setDefault(paymentMethodId: string) {
    return invoke<{ success: boolean; default_payment_method_id: string }>(
      'stripe-save-payment-method',
      { action: 'set_default', payment_method_id: paymentMethodId },
    );
  },

  remove(paymentMethodId: string) {
    return invoke<{ success: boolean }>('stripe-remove-payment-method', {
      payment_method_id: paymentMethodId,
    });
  },

  payWithSavedMethod(input: {
    paymentIntentId: string;
    paymentMethodId: string;
    paymentId: string;
    rollReviewId: string;
    instructorId: string;
  }) {
    return invoke<{ success: boolean; status: string; client_secret: string | null }>(
      'stripe-pay-with-saved-method',
      {
        payment_intent_id: input.paymentIntentId,
        payment_method_id: input.paymentMethodId,
        payment_id: input.paymentId,
        roll_review_id: input.rollReviewId,
        instructor_id: input.instructorId,
      },
    );
  },
};
